<div *ngIf="loaderService.loading$ | async" class="loader-overlay">
    <!-- <div class="spinner-border" style="color: #29A329" role="status">
        <span class="visually-hidden">Loading...</span>
    </div> -->
    <div class="loader"></div>
</div>